import { db } from './Database';

export interface TruckLayout {
    id?: number;
    shippingModeId: number;
    pickupName: string;
    deliveryName: string;
    pickupPhone: number;
    deliveryPhone: number;
    pickupEmail: string;
    deliveryEmail: string;
    startingMileage: number;
    endingMileage: number;
    totalMilesDriven: number;
    suspensionModel: string;
    truckCondition: string;
    year: number;
    airbags: string;
    lockBarsStraps: string;
    truckLayout?: File | null;
    createdAt?: string;
    updatedAt?: string;
}

export class TruckLayoutService {
    // Get truck layout details for a shipping mode
        static async getTruckLayoutDetails(shippingModeId: number): Promise<{ layout: TruckLayout | null }> {
        try {
            const layout = await db.postShipTruckTestLayouts
                .where('shippingModeId')
                .equals(shippingModeId)
                .first();

            return {
                // message: 'Success',
                layout: layout || null
            };
        } catch (error) {
            console.error('Error getting truck layout details:', error);
            throw error;
        }
    }

    // Create or update truck layout
    static async createTruckLayout(data: { layoutData: TruckLayout }): Promise<{ layout: TruckLayout }> {
        const { layoutData } = data;

        return await db.transaction('rw', [db.postShipTruckTestLayouts], async () => {
            try {
                const timestamp = new Date().toISOString();
                let layout;

                // Check if layout exists
                const existingLayout = await db.postShipTruckTestLayouts
                    .where('shippingModeId')
                    .equals(layoutData.shippingModeId)
                    .first();

                if (existingLayout) {
                    // Update existing layout
                    await db.postShipTruckTestLayouts.update(existingLayout.id!, {
                        ...layoutData,
                        updatedAt: timestamp
                    });
                    layout = await db.postShipTruckTestLayouts.get(existingLayout.id!);
                } else {
                    // Create new layout
                    const id = await db.postShipTruckTestLayouts.add({
                        ...layoutData,
                        createdAt: timestamp,
                        updatedAt: timestamp
                    });
                    layout = await db.postShipTruckTestLayouts.get(id);
                }

                if (!layout) {
                    throw new Error('Failed to create/update truck layout');
                }

                return {
                    message: 'Success',
                    layout
                };
            } catch (error) {
                console.error('Error creating/updating truck layout:', error);
                throw error;
            }
        });
    }
}
